import {ProductCollectionComponent} from "./ProductCollectionComponent";
import React from "react";

export default function GlobalProvider() {

    const pathname = window.location.pathname; // "/mirsalari"
    const segment = pathname.split("/")[1];    // "mirsalari"

    localStorage.setItem("pending_shop_key", segment)
    return <ProductCollectionComponent id={segment}/>

}
